
export default {
	init() {

		const $load_shops_wrapper = $("#mozaik-shop")
		const $load_shops_skeleton = $("#mozaik-shop .shop-skeleton")
		const $posts_wrapper = $("#mozaik-shop .more-posts")
		const $loadmore_button = $("#mozaik-shop .loadmore-category")
		const $more_wrapper = $("#mozaik-shop .more-wrapper")
		let loaded_post_ids = []
		let page = 1
		let activeRequest = null
		let requestSerial = 0

		if ($load_shops_wrapper.length > 0) {

			
			//  Initial loading of posts
			let loaded_post_element = $("#loaded_post_ids")
			
			if (loaded_post_element.length) {
				if (loaded_post_element.val() != "") {
					loaded_post_ids = loaded_post_element.val().split(",") // prepare visible shops ID lis
				}
			}
			
			loadShops()

			// Load More button trigger
			$loadmore_button.on('click', function (e) {
				e.preventDefault()
				loadShops(true)
			})

			// Change Filters
			$("input[type=checkbox][name=product_cat], input[type=checkbox][name=product_brand], select[name=order_select], input[type=checkbox][name=color_attr], input[type=checkbox][name=size_attr], input[type=radio][name=price_attr]").on('change', function () {
				page = 1
				loaded_post_ids = []
				// return Load more pages button
				$more_wrapper.css({ visibility: "visible" })
				loadShops()
			})

		}
		
		function loadShops(loadmore = false) {
			// console.log("Loading shops...")

			let filterValues = getFilterValues()
			const countSpan = $("#res-count")
			countSpan.hide()

			// console.log("Loading shops with filter values: ", filterValues)

			const requestedPage = loadmore ? page + 1 : 1

			if (!loadmore) {
				//skeleton
				$load_shops_skeleton.addClass("grid").show()
				$posts_wrapper.removeClass("grid").addClass("hidden")
			}

			const requestId = ++requestSerial
			if (activeRequest) {
				activeRequest.abort()
			}
					
			const data = {
				page: requestedPage,
				loaded_post_ids: loaded_post_ids,
				product_cat: filterValues.product_cat,
				product_brand: filterValues.product_brand,
				order_select: filterValues.order_select,
				color: filterValues.color,
				size: filterValues.size,
				price: filterValues.price,
			}

			// console.log(data)


			activeRequest = $.ajax({
				url: '/wp-json/vivi/v1/shop',
				method: 'POST',
				data: data,
				beforeSend: function () {
					// Load more button
					if($loadmore_button.length > 0) {
						$loadmore_button.prop("disabled", true).text(loading_text)
					}
				},
				success: function (response) {

					// console.log("Response from shops load: ", response)

					if (requestId === requestSerial && response) {
						if (loadmore) {
							$posts_wrapper.append(response.content)
						} else {
							$posts_wrapper.html(response.content)
							
							//skeleton
							$load_shops_skeleton.hide()
							$posts_wrapper.removeClass("hidden").addClass("grid")
						}

						page = requestedPage
						loaded_post_ids = Array.isArray(response.loaded_post_ids) ? response.loaded_post_ids : []

						// Show the button only while the API has unseen products.
						const hasMore = typeof response.has_more === "boolean"
							? response.has_more
							: response.total_posts_count > response.current_count
						$more_wrapper.css({ visibility: hasMore ? "visible" : "hidden" })
						
						// Update Counter
						if(countSpan.length) {
							countSpan.text("(" + response.total_posts_count + ")").show()
						}
					}
				},
				error: function (xhr, status) {
					if (requestId !== requestSerial || status === "abort") {
						return
					}

					$load_shops_skeleton.hide()
					$posts_wrapper.removeClass("hidden").addClass("grid")
					console.error("Shop products could not be loaded.", status)
				},
				complete: function () {
					if (requestId !== requestSerial) {
						return
					}

					activeRequest = null
					$loadmore_button.prop("disabled", false).text(loading_more_text_simple)
				},
			})
		}


		function getFilterValues() {
			
			let product_cat = $("input[name='product_cat']:checked").map(function () {
				return $(this).val();
			}).get()
			
			let product_brand = $("input[name='product_brand']:checked").map(function () {
				return $(this).val();
			}).get()
			
			let order_select = $("select[name='order_select']").val()
			let price_select = $("input[name='price_attr']:checked").length > 0 ? $("input[name='price_attr']:checked")[0].value : null

			let color_select = $("input[name='color_attr']:checked").map(function () {
				return this.value
			}).get()

			let size_select = $("input[name='size_attr']:checked").map(function () {
				return this.value
			}).get()

        
            return {
                'product_cat': product_cat, 
                'product_brand': product_brand, 
				'order_select': order_select,
				'color': color_select,
				'size': size_select,
				'price': price_select,
            }
		}
		
	}
}
